import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C01AccordionProps = RenderingProps<
  C01AccordionFields,
  C01AccordionRenderingPramas,
  AccordionPlaceholder
>;

export type AccordionPlaceholder = {
  'accordion-item-container'?: {
    uid?: string;
  }[];
};

export type C01AccordionFields = {
  Title?: Field<string>;
  TitleType?: KeyValuePair;
  TitleIcon?: KeyValuePair;
  TopSupportingCopy?: RichTextField;
  BottomSupportingCopy?: RichTextField;
};

export type C01AccordionRenderingPramas = {
  TitleAlignment?: string;
  IconPlacement?: string;
  OpenFirstItem?: boolean;
  LimitToSingleItem?: boolean;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
